export const Default_SimulationTitle = 'New Simulation';
//# sourceMappingURL=types.js.map